// extracted by mini-css-extract-plugin
export default {"address":"LocacionSection_address__Iq4g4"};